export const validEmail = new RegExp("\\S+@\\S+\\.\\S+");
export const validPersonNumber = new RegExp("^\\d{10,12}$");
export const validPhoneNumber = new RegExp("^\\+(?:[0-9] ?){6,14}[0-9]$");
